import 'rxjs/add/operator/debounceTime';
import {Component, ViewChild} from '@angular/core';
import {NavController, NavParams, TextInput, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {ENUM, TAction, TFinanceSide, TImageModel, TMethodoTipo, TPaybookFlag} from "../../../app/enum";
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';

@Component({
    selector: 'page-methodo-menu',
    templateUrl: 'methodo-menu.html',
    providers: []
})
export class MethodoMenuPage {

    ENUM: any = ENUM;
    
    TFinanceSide: any = TFinanceSide;
    TMethodoTipo: any = TMethodoTipo;
    TImageModel: any = TImageModel;

    config: any;
    logado: any;
    rootile: any;
    
    roothodo: any;

    etapa: number;

    userset: any;

    methodoPay: any;
    methodoSide: number;
    rootComanda: any;

    paymentBase: number;
    paymentCash: number;
    
    comandaDoze: boolean;

    akkjson = (window as any).handappMainInstance.appjson;
    monitorAuth = this.akkjson.hotwork;
    monitorBool: boolean = true;

    @ViewChild('inputPayment') inputPayment: TextInput;

    constructor(public navCtrl: NavController, public viewCtrl: ViewController, public navParams: NavParams,
                public util: Util,
                public logadoService: LogadoService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.rootile = this.navParams.get('rootile');

        this.etapa = this.navParams.get('etapa');
        
        this.userset = this.navParams.get('userset');
        
        this.rootComanda = this.navParams.get('rootComanda');
        this.monitorBool = this.navParams.get('monitorBool');

        this.paymentCash = 0; //#DESK
        this.rootComanda.Comandas.forEach(CO => this.paymentCash = this.paymentCash + ENUM.paybookCash(CO, 'Deve'));
        this.paymentBase = this.paymentCash;
        this.comandaDoze = false;

        this.methodoPay = null;
        this.methodoSide = 0;

        if (this.etapa == 0) this.methodoLoad();

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Methodo Menu', '/methodo-menu');

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

        setTimeout(() => {
            if (this.inputPayment) this.inputPayment.setFocus();
        }, 500);

    }

    getTitle() {

        if (this.etapa == 0) return 'Payment';
        if (this.etapa == 1) return this.methodoSide == 2 ? 'CRÉDITO' : 'DÉBITO';
        return '';

    }



    /** ************************************************ WEBSTOR ************************************************** **/
    /** ************************************************ etapa-0 ************************************************** **/


    paymentGate(methodo) {

        this.methodoPay = methodo;
        this.etapa = 2;

    }

    methodoCode(methodo) {

        let onDone = () => {

            this.methodoPay = methodo;
            this.etapa = 1;
    
        };

        if (methodo.MethodoID == 200) {

            /** OPEN **/
            let buttons: Array<any> = [];
            if (this.logado.Profile.ProfileZito) //#Develop -> BB-API
            buttons.push({text: 'QRCode',   handler: () => this.paymentGate(methodo)});
            buttons.push({text: 'Manual',   handler: () => onDone()});
            this.util.sheetOpen(buttons, 'PIX');

            return;
        }

        onDone();

    }

    tecladoOkey(btn) {
        
        let paymentText = this.util.dinheiro(this.paymentCash);
        paymentText = paymentText.replace('R$', '');
        paymentText = paymentText.replace(',',  '');
        paymentText = paymentText.replace('.',  '');
        paymentText = paymentText.replace(' ',  '');

        if (btn == 'ok') {

            this.paymentSend();
            
        }

        else if (btn == 'cancel') {
            this.dismiss();
        }

        else if (btn == 'erase') {
            if (paymentText.length) paymentText = paymentText.substring(0, paymentText.length-1);
        }

        else if (btn == 'left-thin') {
            if (paymentText.length) paymentText = paymentText.substring(0, paymentText.length-1);
        }

        else if (btn == 'dot') {
            //this.tecladoText = this.tecladoText + '.';
        }

        else {
            if (paymentText.length <= 10) paymentText = paymentText + btn;
        }

        paymentText = paymentText.substring(0, paymentText.length-2) + '.' + paymentText.substring(paymentText.length-2, 99);
        this.paymentCash = parseFloat(paymentText);

    }



    methodoLoad() {

        let onDone = (data) => {

            this.roothodo = data;
            this.etapa = 0;

        };

        if (this.roothodo) {
            onDone(this.roothodo);
            return;
        }

        let loading = this.util.loadingDots();
        loading.present();

        let hotspotID = this.monitorAuth.Hotspot.HotspotID;
        this.util.monitorDesk(this.monitorBool, 'DESK-Methodo', hotspotID, '', TAction.acLoad)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onDone(data),
                erro => this.util.alertResult(erro)
            );

    }




    //#GAMBI - MONITOR-DESK
    paymentSend(assinarBool: boolean = false) {

        let permitirBool = (!this.rootComanda.Comandas[0].ComandaID && this.paymentBase == 0);
        if (this.paymentCash == 0 && !permitirBool) return;

        let comandas = [];
        this.rootComanda.Comandas.forEach(CM => comandas.push({ComandaID: CM.ComandaID}));
        
        let payments = [];
        if (this.paymentCash > 0 && !assinarBool) {
            payments.push({
                MethodoID: this.methodoPay.MethodoID,
                AccountID: 0,
                GatewayID: 0,
                PaymentSide: (this.methodoSide == 2 ? TFinanceSide.cdCredito : TFinanceSide.cdDebito),
                PaymentCash: this.paymentCash,
            });
        }

        let json = {
            CashierID: 0,
            UsuarioID: 0,
            AssinarID: (assinarBool ? this.logado.Profile.ProfileID : 0),
            Comandas: comandas,
            Payments: payments,
            ComandaDoze: this.comandaDoze,

            //Controle-Tela
            _finishTela: false,
        }

        if (!this.rootComanda.Comandas[0].ComandaID) {
            this.dismiss(payments);
            return;
        }


        let onDone = (data) => {
            //#NEGATIVO - está adicionando crédito
            //#ZERADO   - finaliza, recebeu tudo
            //#POSITIVO - está devento, continua na tela anterior
            json._finishTela = (this.paymentBase - this.paymentCash == 0);
            if (json._finishTela) this.rootComanda.Comandas.forEach(CO => CO.PaybookFlag = TPaybookFlag.pfLock);

            //Finalizou recebido
            if (json._finishTela) {
                if (!this.comandaDoze) this.navCtrl.getPrevious().dismiss(); //#G - Force close PaybookMenu finalizou tudo "AGILIDADE"!
                this.dismiss(json); //NAO precisa carregar paybook novamente (Comanda Reload)
            }

            //Continuar lançando
            if (!json._finishTela) {
                this.dismiss(json); //SIM precisa carregar paybook novamente (para vir parcela e payment)
            }
        };

        let loading = this.util.loadingDots();
        loading.present();

        let hotspotID = this.monitorAuth.Hotspot.HotspotID;
        this.util.monitorDesk(this.monitorBool, 'DESK-Payment', hotspotID, '', TAction.acSave, json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onDone(data),
                erro => this.util.alertResult(erro)
            );

    }


    dismiss(json?) {

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss(json);
            return;
        }

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/methodo-menu/methodo-menu.ts